import * as React from 'react';

import { IPaySimpleError } from 'src/store/modules/paysimplecheckouttoken/reducers';
import { IEcheckPayment } from 'src/services/paySimple/paySimpleService';

import EcheckImage from 'src/assets/echeckImage';
import paySimpleService from 'src/services/paySimple/paySimpleService';
import './ECheckForm.scss';
import ECheckInvoices from './components/ECheckInvoices';
import Loader from 'src/components/common/Loader';
import { whiteSpacesValidation as hasWhiteSpaces } from 'src/utils/whiteSpacesValidation';
import env from 'src/shared/env';

export interface IInvoiceEcheck {
  transactionId: number;
  invoiceDate: string;
  invoiceNumber: number;
  orderNumber: number;
  payment: number;
  remaining: number;
  total: number;
  notes: string;
}

interface IECheckFormState {
  company: string;
  firstName: string;
  lastName: string;
  addressLine: string;
  city: string;
  state: string;
  zipCode: string;
  phone: string;
  email: string;
  fullName: string;
  paysimple: any;
  iframeError: {
    show: boolean;
    message: string;
  };
  showError: boolean;
  isPending: boolean;
}

interface IECheckFormProps {
  handleCloseModal: () => void;
  getCheckoutToken: () => void;
  createPayment: (params: IEcheckPayment) => void;
  jwtToken: string;
  expiration: string;
  isPending: boolean;
  error: IPaySimpleError;
  invoices: IInvoiceEcheck[];
  userAccount: string;
  showTable?: boolean;
}

class ECheckForm extends React.Component<IECheckFormProps, IECheckFormState> {
  constructor(props: any) {
    super(props);

    this.state = {
      company: '',
      firstName: '',
      lastName: '',
      addressLine: '',
      city: '',
      state: '',
      zipCode: '',
      phone: '',
      email: '',
      fullName: '',
      paysimple: null,
      iframeError: {
        show: false,
        message: ''
      },
      showError: true,
      isPending: false
    };
  }

  private handleChangeBillingInformation = (e: any) => {
    const value: any = e.target.value;

    if (!hasWhiteSpaces(value) || !value) {
      this.setState({
        ...this.state,
        [e.target.name]: value
      });
    }
  };

  private handleSubmit = (e: any) => {
    e.preventDefault();

    const customer = {
      ...this.state
    };

    delete customer.paysimple;
    delete customer.fullName;
    this.state.paysimple.send.retrieveAccount(customer);
  };

  private getInvoiceData = () => {
    let total: number = 0;
    const invoices = this.props.invoices.map(invoice => {
      total += Number(invoice.payment);

      const newInvoice = {
        invoiceNumber: invoice.invoiceNumber,
        orderNumber: invoice.orderNumber,
        transactionId: invoice.transactionId,
        paymentAmount: invoice.payment,
        reasonNotes: invoice.notes
      };

      return newInvoice;
    });

    return {
      amount: total,
      invoices
    };
  };

  private onAccountRetrieved = (accountInfo: any, props: any) => {
    const invoiceData = this.getInvoiceData();
    const paymentData = {
      email: this.state.email,
      invoices: invoiceData.invoices,
      payment: {
        accountId: accountInfo.account.id,
        amount: invoiceData.amount,
        paymentToken: accountInfo.paymentToken
      },
      signature: this.state.fullName
    };
    this.setState({ isPending: true });
    paySimpleService
      .createECheckPayment(paymentData)
      .then(res => {
        this.setState({ isPending: false });
        props.history.push({
          pathname: '/invoices/payResponse',
          state: {
            orderlistLength: invoiceData.invoices.length,
            creditUsed: invoiceData.amount,
            trackingNumber: res.trackingNumber
          }
        });
        this.props.handleCloseModal();
      })
      .catch(error => {
        this.setState({ isPending: false });
        console.log(error);
      });
    // this.props.createPayment(paymentData);
    // props.history.push({
    //   pathname: '/invoices/payResponse',
    //   state: {
    //     orderlistLength: invoiceData.invoices.length,
    //     creditUsed: invoiceData.amount,
    //     // trackingNumber:
    //   }
    // });
    // this.props.handleCloseModal();
  };

  private handleIframeError = (error: any) => {
    this.setState({
      iframeError: {
        show: true,
        message: `Unable to be processed: ${error.errors[0].message}`
      }
    });
  };

  public componentDidMount() {
    this.props.getCheckoutToken();
  }

  public componentDidUpdate(prevProps: IECheckFormProps) {
    if (prevProps.jwtToken !== this.props.jwtToken) {
      const paysimple = (window as any).paysimpleJs({
        container: document.getElementById('rp-paysimple-form'),
        auth: { token: this.props.jwtToken },
        bypassPostalCodeValidation: false,
        preventAutocomplete: false,
        styles: {
          body: {
            backgroundColor: '#ffffff'
          },
          'label.routingNumber': {
            fontSize: '12px'
          },
          'label.accountNumber': {
            fontSize: '12px'
          },
          'label.accountType': {
            fontSize: '12px'
          },
          'label.bankName': {
            fontSize: '12px'
          },
          'field.routingNumber': {
            border: '1px solid black',
            borderRadius: '0',
            backgroundColor: '#f9f9f9'
          },
          'field.accountNumber': {
            border: '1px solid black',
            borderRadius: '0',
            backgroundColor: '#f9f9f9'
          },
          'field.accountType': {
            border: '1px solid black',
            borderRadius: '1px',
            backgroundColor: '#f9f9f9'
          },
          'field.bankName': {
            border: '1px solid black',
            borderRadius: '0',
            backgroundColor: '#f9f9f9'
          }
        }
      });

      paysimple.send.setMode('ach-key-enter');

      paysimple.on('accountRetrieved', (accountInfo: any) => {
        this.onAccountRetrieved(accountInfo, this.props);
      });

      paysimple.on('httpError', this.handleIframeError);

      if (this.props.jwtToken) {
        this.setState({
          paysimple,
          showError: false
        });
      } else {
        this.setState({
          paysimple,
          showError: true
        });
      }
    }
  }

  public render() {
    return (
      <div className="rp-echeck-form container-fluid">
        <div className="rp-echeck-header d-flex align-items-center justify-content-between">
          <h3 className="rp-echeck-subtitle">Billing information:</h3>
          <i
            className="rpds-close close-modal"
            onClick={this.props.handleCloseModal}
          />
        </div>
        {this.state.isPending && !this.props.jwtToken ? (
          <Loader />
        ) : (
          <form className="row" onSubmit={this.handleSubmit}>
            <div className="rp-echeck-form-field col-12">
              <label>
                Company Name: <span className="rp-echeck-form-required">*</span>
              </label>
              <input
                value={this.state.company}
                name="company"
                onChange={this.handleChangeBillingInformation}
                type="text"
                required={true}
              />
            </div>
            <div className="rp-echeck-form-field col-12 col-md-6">
              <label>
                First Name: <span className="rp-echeck-form-required">*</span>
              </label>
              <input
                value={this.state.firstName}
                name="firstName"
                onChange={this.handleChangeBillingInformation}
                type="text"
                required={true}
              />
            </div>
            <div className="rp-echeck-form-field col-12 col-md-6">
              <label>
                Last Name: <span className="rp-echeck-form-required">*</span>
              </label>
              <input
                value={this.state.lastName}
                name="lastName"
                onChange={this.handleChangeBillingInformation}
                type="text"
                required={true}
              />
            </div>
            <div className="rp-echeck-form-field col-12">
              <label>Address Line:</label>
              <input
                value={this.state.addressLine}
                name="addressLine"
                onChange={this.handleChangeBillingInformation}
                type="text"
              />
            </div>
            <div className="rp-echeck-form-field col-12 col-md-4">
              <label>City:</label>
              <input
                value={this.state.city}
                name="city"
                onChange={this.handleChangeBillingInformation}
                type="text"
              />
            </div>
            <div className="rp-echeck-form-field col-12 col-md-4">
              <label>State:</label>
              <input
                value={this.state.state}
                name="state"
                onChange={this.handleChangeBillingInformation}
                type="text"
              />
            </div>
            <div className="rp-echeck-form-field col-12 col-md-4">
              <label>
                {env.REACT_APP_BASE_ENVIRONMENT === 'CA'
                  ? 'Postal Code:'
                  : 'ZIP Code:'}
              </label>
              <input
                value={this.state.zipCode}
                name="zipCode"
                onChange={this.handleChangeBillingInformation}
                type="text"
              />
            </div>
            <div className="rp-echeck-form-field col-12 col-md-6">
              <label>
                Phone:<span className="rp-echeck-form-required">*</span>
              </label>
              <input
                value={this.state.phone}
                name="phone"
                onChange={this.handleChangeBillingInformation}
                type="text"
                required={true}
              />
            </div>
            <div className="rp-echeck-form-field col-12 col-md-6">
              <label>
                Email: <span className="rp-echeck-form-required">*</span>
              </label>
              <input
                value={this.state.email}
                name="email"
                onChange={this.handleChangeBillingInformation}
                type="email"
                required={true}
              />
            </div>
            {this.props.error.hasFailed && this.state.showError ? (
              <div className="col-12 d-flex justify-content-center">
                <span className="rp-echeck-form-error">
                  Error on load iframe. Please, try again later.
                </span>
              </div>
            ) : null}
            <div id="rp-paysimple-form" className="col-12">
              {/* It will be inserted here */}
            </div>
            <div className="col-12 d-flex justify-content-center">
              <img src={EcheckImage} className="img-fluid" />
            </div>
            <div className="col-12 d-flex justify-content-start">
              <p className="rp-paysimple-legend">
                I hereby authorized Reliable Parts to withdraw the stated amount
                of funds from the account listed above.
              </p>
            </div>
            <div className="col-12 d-flex justify-content-start">
              <p className="rp-paysimple-legend strong">
                Enter your full name here to signify your electronic signature.
              </p>
            </div>
            <div className="rp-echeck-form-field col-12">
              <label>
                Full Name: <span className="rp-echeck-form-required">*</span>
              </label>
              <input
                value={this.state.fullName}
                name="fullName"
                onChange={this.handleChangeBillingInformation}
                type="text"
                required={true}
              />
            </div>
            <div className="col-md-6 d-flex justify-content-center justify-content-md-end epay-cancel-btn">
              <button
                type="button"
                className="secondary-button"
                onClick={this.props.handleCloseModal}
              >
                CANCEL
              </button>
            </div>
            <div className="col-md-6 d-flex flex-column align-items-center align-items-md-start">
              <button
                type="submit"
                className={
                  'primary-button ' +
                  (this.props.error.hasFailed && this.state.showError
                    ? 'disabled'
                    : '')
                }
                disabled={this.props.error.hasFailed && this.state.showError}
              >
                SUBMIT
              </button>
              {this.state.iframeError.show && (
                <p className="rp-echeck-iframe-error">
                  {this.state.iframeError.message}
                </p>
              )}
            </div>
            {this.props.showTable ? (
              <ECheckInvoices
                invoices={this.props.invoices}
                userAccount={this.props.userAccount}
              />
            ) : null}
          </form>
        )}
      </div>
    );
  }
}

export default ECheckForm;
